import { HttpClient } from '@angular/common/http';
import { APICONSTANTS } from '../../constants/api-constants';
import { Injectable } from '@angular/core';
import { GenericCrudService } from '../basic/generic.crud.service';
import { ToastrService } from 'ngx-toastr';
import { SocieteModel, SocieteNode } from '../../models/simple-types/societe.model';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HostnameService } from '../basic/hostname.service';
import { GenericLibelleService } from '../basic/generic-libelle.service';

@Injectable()
export class SocieteService extends GenericLibelleService<SocieteModel> {
  constructor(http: HttpClient,
              protected toastrService: ToastrService,
              protected hostnameService: HostnameService) {
    super(http, toastrService, APICONSTANTS.ROUTESOCIETE, hostnameService);
  }
  getAllForBc(): Observable<SocieteModel[]> {
    return this.http.get<SocieteModel[]>(APICONSTANTS.URLAPI.value + this.route + 'GetAllForBc/')
    .pipe(catchError(err => this.requestCatchError(err, 'GetAllForBc')));
  }

  getAllForCreateBc(): Observable<SocieteModel[]> {
    return this.http.get<SocieteModel[]>(APICONSTANTS.URLAPI.value + this.route + 'getAllForCreateBC/')
    .pipe(catchError(err => this.requestCatchError(err, 'getAllForCreateBC')));
  }

  getAllForBp(): Observable<SocieteModel[]> {
    return this.http.get<SocieteModel[]>(APICONSTANTS.URLAPI.value + this.route + 'GetAllForBp/')
    .pipe(catchError(err => this.requestCatchError(err, 'GetAllForBp')));
  }

  getAllForInterfaceSage(): Observable<SocieteModel[]> {
    return this.http.get<SocieteModel[]>(APICONSTANTS.URLAPI.value + this.route + 'GetAllForInterfaceSage/')
    .pipe(catchError(err => this.requestCatchError(err, 'GetAllForInterfaceSage')));
  }

  getAllWithCa1(): Observable<SocieteNode[]> {
    return this.http.get<SocieteNode[]>(APICONSTANTS.URLAPI.value + this.route + 'GetAllWithCa1/')
    .pipe(catchError(err => this.requestCatchError(err, 'GetAllWithCa1')));
  }

  getAllFromAdmin(): Observable<SocieteModel[]> {
    return this.http.get<SocieteModel[]>(APICONSTANTS.URLAPI.value + this.route + 'GetAllFromAdmin/')
    .pipe(catchError(err => this.requestCatchError(err, 'GetAllFromAdmin')));
  }

  getAllFromAdminReferentiel(): Observable<SocieteModel[]> {
    return this.http.get<SocieteModel[]>(APICONSTANTS.URLAPI.value + this.route + 'GetAllFromAdminReferentiel/')
    .pipe(catchError(err => this.requestCatchError(err, 'GetAllFromAdminReferentiel')));
  }

  desactivation(id: number, t: SocieteModel): Observable<SocieteModel> {
    return this.http.put<SocieteModel>(APICONSTANTS.URLAPI.value + this.route + 'desactivation/' + id, t, {})
    .pipe(catchError( err => this.requestCatchError(err, 'Update')));
  }
}
